import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteFamilyMedicalHistoryInformation: Map<string, ConfirmationData> = new Map([
    ["99bee2f1-f22f-4f28-a693-7bdef1e3c1c6|0f775e48-c1f9-4249-8f3c-bdc40c9f4718", { hidden: true }],
]);



